// 设置 rem 函数
function setRem() {
  // 3200 默认大小20px; 3200px = 160rem ;每个元素px基础上/20
  let htmlWidth =
    document.documentElement.clientWidth || document.body.clientWidth;
  // console.log('页面宽度', htmlWidth)
  // 得到html的Dom元素
  let htmlDom = document.getElementsByTagName("html")[0];
  htmlDom.style.fontSize = htmlWidth/ 96 + "px"; // 20px
}

setRem();

// 初始化
// setRem()
// 改变窗口大小时重新设置 rem
window.onresize = function() {
  setRem();
};

function myBrowser() {
  var userAgent = navigator.userAgent; // 取得浏览器的userAgent字符串
  var isOpera = userAgent.indexOf("Opera") > -1;
  if (isOpera) {
    // 判断是否Opera浏览器
    return "Opera";
  }
  if (userAgent.indexOf("Firefox") > -1) {
    // 判断是否Firefox浏览器
    return "FF";
  }
  if (userAgent.indexOf("Chrome") > -1) {
    return "Chrome";
  }
  if (userAgent.indexOf("Safari") > -1) {
    // 判断是否Safari浏览器
    return "Safari";
  }
  if (
    userAgent.indexOf("compatible") > -1 &&
    userAgent.indexOf("MSIE") > -1 &&
    !isOpera
  ) {
    // 判断是否IE浏览器
    return "IE";
  }
}
